<template>
  <v-row no-gutters class="pt-10 pb-5" justify="center">
    <v-col cols="12" lg="10" xl="8">
      <v-row no-gutters align="center" class="pb-4">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
                fab
                depressed
                dark
                small
                icon
                color="secondary"
                class="mr-3"
                v-bind="attrs"
                v-on="on"
                :to="{ name: 'Request' }"
            >
              <v-icon dark>
                mdi-arrow-left
              </v-icon>
            </v-btn>
          </template>
          <span>Indietro</span>
        </v-tooltip>
        <v-col>
          <h3 v-if="!this.$route.params.id">Aggiungi Polizza</h3>
          <h3 v-if="this.$route.params.id">Dettagli Polizza</h3>
        </v-col>
        <v-col cols="2">
          <select v-model.number="status" v-if="this.$route.params.id && this.$store.state.auth.role === 'admin'" @change="changed" class="primary custom-select input" style="color: white">
            <option value="1">
              Account
            </option>
            <option value="2">
              Ufficio Tecnico
            </option>
            <option value="3">
              Da inviare
            </option>
            <option value="4">
              Inviata
            </option>
            <option value="5">
              Accettata
            </option>
            <option value="6">
              Rifiutata
            </option>
            <option value="7">
              Polizza emessa
            </option>
            <option value="8">
              Senza Seguito
            </option>
            <option value="null" disabled selected>Stato</option>
          </select>
        </v-col>
        <v-tooltip bottom v-if="this.$route.params.id && report">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
                fab
                depressed
                dark
                small
                class="ml-2 mr-2"
                color="primary"
                v-bind="attrs"
                v-on="on"
                target="_blank"
                icon
                :href="report"
            >
              <v-icon dark>
                mdi-package-down
              </v-icon>
            </v-btn>
          </template>
          <span>Download PDF</span>
        </v-tooltip>
        <v-tooltip bottom v-if="this.$route.params.id && zip">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
                fab
                depressed
                dark
                small
                icon
                class="ml-2 mr-2"
                color="primary"
                v-bind="attrs"
                v-on="on"
                :href="zip"
            >
              <v-icon dark>
                mdi-zip-box
              </v-icon>
            </v-btn>
          </template>
          <span>Download ZIP</span>
        </v-tooltip>
        <v-tooltip v-if="this.$store.state.auth.role === 'admin' || this.$store.state.auth.role === 'user' && status < 2 || this.$store.state.auth.role === 'expert' && status < 3 || this.$store.state.auth.role === 'company' && status <= 4" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
                fab
                depressed
                dark
                small
                icon
                class="mr-5 ml-2"
                color="primary"
                v-bind="attrs"
                v-on="on"
                :disabled="$store.state.auth.role === 'company'"
                @click="store()"
            >
              <v-icon dark v-if="!loading">
                mdi-check
              </v-icon>
              <v-progress-circular
                  v-else
                  indeterminate
                  color="primary"
                  :size="20"
                  :width="2"
              ></v-progress-circular>
            </v-btn>
          </template>
          <span>Salva</span>
        </v-tooltip>
        <!-- account -->
        <v-btn outlined @click="confirm=true" color="primary" :disabled="status >= 2" v-if="!confirm && this.$store.state.auth.role === 'user'">
          <small v-if="status < 2">Invia</small>
          <small v-else>Inviata</small>
        </v-btn>
        <v-btn depressed @click="store(true)" color="primary" :disabled="status >= 2 || confirmation" v-if="confirm && this.$store.state.auth.role === 'user'">
          <small>Conferma</small>
        </v-btn>
        <v-btn outlined @click="confirm2=true" class="ml-4" color="primary" :disabled="status >= 8" v-if="!confirm2 && this.$store.state.auth.role === 'user'">
          <small v-if="status < 8">Senza Seguito</small>
          <small v-else>Senza Seguito</small>
        </v-btn>
        <v-btn depressed @click="status = 8; store(true)" color="primary" class="ml-4" v-if="confirm2 && this.$store.state.auth.role === 'user'">
          <small>Conferma</small>
        </v-btn>
        <!-- expert -->
        <v-btn outlined @click="confirm=true" color="primary" :disabled="status >= 3" v-if="!confirm && this.$store.state.auth.role === 'expert'">
          <small v-if="status < 3">Invia</small>
          <small v-else>Inviata</small>
        </v-btn>
        <v-btn depressed @click="store(true)" color="primary" :disabled="status >= 3 || confirmation" v-if="confirm && this.$store.state.auth.role === 'expert'">
          <small>Conferma</small>
        </v-btn>
        <!-- company -->
        <v-btn outlined @click="status = 6; confirm=true" color="error" :disabled="status >= 5" v-if="!confirm && this.$store.state.auth.role === 'company' && status !== 5">
          <small v-if="status < 5">Rifiuta</small>
          <small v-else>Rifiutata</small>
        </v-btn>
        <v-btn outlined @click="status = 5; confirm=true" color="primary" class="ml-3" :disabled="status >= 5" v-if="!confirm && this.$store.state.auth.role === 'company' && status !== 6">
          <small v-if="status < 5">Accetta</small>
          <small v-else>Accettata</small>
        </v-btn>
        <v-btn :href="filesb[0]" v-if="filesb && filesb.length > 0 && this.$store.state.auth.role === 'company' || filesb && filesb.length > 0 && this.$store.state.auth.role === 'user'" target="_blank" class="primary">
          <small>Scarica la bozza di polizza</small>
        </v-btn>
        <v-btn depressed @click="store(true)" :color="(status === 5) ? 'primary' : 'error'" :disabled="confirmation" v-if="confirm && this.$store.state.auth.role === 'company'">
          <small v-if="status === 5">Conferma</small>
          <small v-else>Rifiuta</small>
        </v-btn>

        <v-btn outlined disabled v-if="this.$store.state.auth.role === 'admin'">
          <small>
          <span v-if="status === 0">Bozza</span>
          <span v-if="status === 1">Account</span>
          <span v-if="status === 2">Ufficio Tecnico</span>
          <span v-if="status === 3">Da inviare</span>
          <span v-if="status === 4">Inviata alla compagnia</span>
          <span v-if="status === 5">Accettata</span>
          <span v-if="status === 6">Rifiutata</span>
          <span v-if="status === 7">Polizza emessa</span>
          <span v-if="status === 8">Senza Seguito</span>
          </small>
        </v-btn>
      </v-row>
      <v-row no-gutters v-if="error" class="pb-5">
        <v-col cols="12" class="error--text text-right">
          {{error}}
        </v-col>
      </v-row>
      <v-row no-gutters class="white bra align-start pa-3">
        <app-subject name="Contraente" :status="status" :disabled="status >=2 && this.$store.state.auth.role !== 'admin'" class="pa-3" :list.sync="holders" required></app-subject>
        <app-subject name="Beneficiario"  :status="status" :disabled="status >=2 && this.$store.state.auth.role !== 'admin'" class="pa-3 pt-0" :list.sync="beneficiaries" required></app-subject>
        <app-subject name="Coobbligato"  :status="status" :disabled="status >=2 && this.$store.state.auth.role !== 'admin'" class="pa-3 pt-0" :list.sync="obliged"></app-subject>
        <v-col cols="6" class="pa-3 pt-0">
          <span class="label">Tipologia di garanzia <small class="error--text">(obbligatorio)</small></span>
          <select v-model="data.guarantee" :disabled="status >=2 && this.$store.state.auth.role !== 'admin'" class="custom-select input" :class="{'inputWarn': !data.guarantee}">
            <option :value="item.data().title" v-for="item in guarantees" :key="item.id">
              {{item.data().title}}
            </option>
            <option value="null" disabled selected>Tipologia di garanzia</option>
          </select>
        </v-col>
        <v-col cols="6" class="pa-3 pt-0">
          <span class="label">Sub Account</span>
          <input type="text" :readonly="status >= 2 && this.$store.state.auth.role !== 'admin'" placeholder="Indicare eventuale sub account" class="input" v-model="data.subaccount">
        </v-col>
        <v-col cols="6" class="pa-3 pt-0">
          <span class="label">Oggetto <small class="error--text">(obbligatorio)</small></span>
          <textarea class="input" :readonly="status >=2 && this.$store.state.auth.role !== 'admin'" :class="{'inputWarn': !data.subject}" v-model="data.subject" rows="5" placeholder="Oggetto"></textarea>
        </v-col>
        <v-col cols="6" class="pa-3 pt-0">
          <span class="label">Note</span>
          <textarea class="input" :readonly="status >=2 && this.$store.state.auth.role !== 'admin'" v-model="data.notes" rows="5" placeholder="Note"></textarea>
        </v-col>
        <v-col cols="12" class="pa-3 pt-0">
          <span class="label">Documentazione tecnica <small class="error--text">(obbligatorio)</small></span>
          <input-file id="docs" :disabled="status >=2 && this.$store.state.auth.role !== 'admin'" :files.sync="files" required></input-file>
        </v-col>
        <v-col cols="12" class="pa-3 pt-0" v-if="status >= 2 && this.$store.state.auth.role !== 'user'">
          <span class="label">Relazione tecnica <small class="error--text">(obbligatorio)</small></span>
          <input-file id="docst" :disabled="status >= 3 && this.$store.state.auth.role !== 'admin'" :files.sync="filest" required></input-file>
        </v-col>
        <v-col cols="12" class="pa-3 pt-0" v-if="status >= 2 && this.$store.state.auth.role !== 'user'">
          <span class="label">Opinione tecnica</span>
          <v-select placeholder="Seleziona opinione tecnica" :readonly="status >=3 && this.$store.state.auth.role !== 'admin'" v-model="data.opinion" :items="options"></v-select>
          <textarea class="input" :readonly="status >=3 && this.$store.state.auth.role !== 'admin'" v-model="data.notes_opinion" rows="5" placeholder="Note opinione tecnica"></textarea>
        </v-col>
        <v-col cols="12" class="pa-3 pt-0" v-if="status >=5 && this.$store.state.auth.role === 'company' || this.$store.state.auth.role === 'admin'">
          <span class="label">Bozza polizza <small class="error--text">(obbligatorio)</small></span>
          <input-file id="docsb" :disabled="status >= 6 && this.$store.state.auth.role !== 'admin'" :files.sync="filesb" :required="status >= 5"></input-file>
        </v-col>
        <v-col cols="5" class="pa-3 pt-0">
          <span class="label">Valido da <small class="error--text">(obbligatorio)</small></span>
          <input type="date"  class="input" :readonly="status >= 2 && this.$store.state.auth.role !== 'admin'" v-model="data.valid_from" :class="{'inputWarn': !data.valid_from}">
        </v-col>
        <v-col cols="5" class="pa-3 pt-0">
          <span class="label">Valido fino <small class="error--text">(obbligatorio)</small></span>
          <input type="date" class="input" :readonly="status >= 2 && this.$store.state.auth.role !== 'admin'" v-model="data.valid_to" :class="{'inputWarn': !data.valid_to}">
        </v-col>
        <v-col cols="2" class="pa-3 pt-0">
          <span class="label">Durata</span>
          <input type="text" class="input" disabled v-model="data.valid_duration">
        </v-col>
        <v-col cols="5" class="pa-3 pt-0">
          <span class="label">Estensione garanzia da</span>
          <input type="date" class="input" :readonly="status >= 2 && this.$store.state.auth.role !== 'admin'" v-model="data.extend_from">
        </v-col>
        <v-col cols="5" class="pa-3 pt-0">
          <span class="label">Estensione garanzia a</span>
          <input type="date" class="input" :readonly="status >= 2 && this.$store.state.auth.role !== 'admin'" v-model="data.extend_to">
        </v-col>
        <v-col cols="2" class="pa-3 pt-0">
          <span class="label">Durata</span>
          <input type="text" class="input" disabled v-model="data.extend_duration">
        </v-col>
      </v-row>
      <v-row no-gutters class="white bra align-start pa-3 mt-5">
        <v-col cols="6" class="pa-3">
          <span class="label">Importo garantito <small class="error--text">(obbligatorio)</small></span>
          <input type="number" step=".01" :readonly="status >= 2 && this.$store.state.auth.role !== 'admin'" placeholder="Importo garantito" class="input" v-model.number="data.sum_insured" :class="{'inputWarn': !data.sum_insured}">
        </v-col>
        <v-col cols="6" class="pa-3">
          <span class="label">Tasso richiesto % <small class="error--text">(obbligatorio)</small></span>
          <input type="number" step=".01" :readonly="status >= 2 && this.$store.state.auth.role !== 'admin'" placeholder="Tasso richiesto %" class="input" v-model.number="data.rate_required" @change="validity(true)" :class="{'inputWarn': !data.rate_required}">
        </v-col>
        <v-col cols="6" class="pa-3">
          <span class="label">Premio finale <small class="error--text">(obbligatorio)</small></span>
          <input type="number" step=".01" :readonly="status >= 2 && this.$store.state.auth.role !== 'admin'" placeholder="Premio finale" class="input" v-model.number="data.insurance_price" @change="validity(false)" :class="{'inputWarn': !data.insurance_price}">
        </v-col>
        <v-col cols="6" class="pa-3">
          <span class="label">Valore del progetto</span>
          <input type="number" step=".01" :readonly="status >= 2 && this.$store.state.auth.role !== 'admin'" placeholder="Valore del progetto" class="input" v-model.number="data.project_value">
        </v-col>
        <v-col cols="6" class="pa-3">
          <span class="label">Tipologia di firma <small class="error--text">(obbligatorio)</small></span>
          <select v-model="data.signature" :disabled="status >=2 && this.$store.state.auth.role !== 'admin'" class="custom-select input" :class="{'inputWarn': !data.signature}">
            <option :value="item.data().title" v-for="item in signatures" :key="item.id">
              {{item.data().title}}
            </option>
            <option value="null" disabled selected>Tipologia di firma</option>
          </select>
        </v-col>
      </v-row>
      <!-- Send to a company -->
      <v-row v-if="status >= 3 && this.$store.state.auth.role === 'admin'" no-gutters class="align-start mt-4">
        <v-col cols="12" class="pa-3">
          <h3>Seleziona la compagnia</h3>
        </v-col>
        <v-col cols="12">
          <v-row no-gutters class="white bra pa-3">
            <v-col cols="4" class="pa-3" v-for="item in companies" :key="item.id">
              <v-checkbox
                  v-model="selected"
                  :disabled="status >= 4"
                  :label="item.email"
                  :value="item.id"
              ></v-checkbox>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<style lang="scss" scoped>
  .label{
    color: var(--v-primary-base);
    font-weight: 500;
  }
  .v-messages theme--light{
    display: none;
  }
</style>

<script>
import { db } from "@/main";
import firebase from "firebase/app";
import AppSubject from "../../components/subject";
import InputFile from "../../components/input/file";
import Storage from "@/services/firestorage";

// @ is an alias to /src
export default {
  name: 'home',
  components: {
    AppSubject,
    InputFile
  },
  async created() {
    if(this.$route.params.id) {
      let snap = await db.collection("requests").doc(this.$route.params.id).get()
      // item data
      let item = snap.data()
      this.report = item.report
      this.zip = item.package
      this.disabled = item.disabled
      this.data = item.data
      this.files = item.files
      this.filest = item.filest
      this.filesb = item.filesb
      this.status = item.status
      if(item.companies) {
        this.selected = [item.companies]
      }
      // holders
      let items = await snap.ref.collection('holders').get()
      if(items) {
        for (const elm of items.docs) {
          let im = elm.data()
          im.id = elm.id
          this.holders.push(im)
        }
      }
      // beneficiaries
      items = await snap.ref.collection('beneficiaries').get()
      if(items) {
        for (const elm of items.docs) {
          let im = elm.data()
          im.id = elm.id
          this.beneficiaries.push(im)
        }
      }
      // obliged
      items = await snap.ref.collection('obliged').get()
      if(items) {
        for (const elm of items.docs) {
          let im = elm.data()
          im.id = elm.id
          this.obliged.push(im)
        }
      }
    }
    db.collection("users").where("role", "==", "company").get()
        .then(querySnapshot => {
          querySnapshot.forEach(elm => {
            let im = elm.data()
            im.id = elm.id
            this.companies.push(im)
          })
        })
    db.collection("guarantees").orderBy("title").get()
        .then(querySnapshot => {
          this.guarantees = querySnapshot.docs
        })
    db.collection("signatures").orderBy("title").get()
        .then(querySnapshot => {
          this.signatures = querySnapshot.docs
        })
    this.$store.commit('loadingStop')
  },
  watch: {
    'status'(final, old) {
      console.log("changed")
      console.log(old)
      console.log(final)
    },
    'data.valid_from'() {
      this.validity(true)
    },
    'data.valid_to'() {
        this.validity(true)
    },
    'data.sum_insured'() {
        this.validity(true)
    },
    'data.extend_from'() {
      this.extension()
    },
    'data.extend_to'() {
      this.extension()
    },
  },
  methods: {
    changed() {
      if (this.$route.params.id && this.status) {
        db.collection('requests').doc(this.$route.params.id).update({
          status: this.status,
          updated_at: firebase.firestore.Timestamp.now()
        })
        self.$router.go()
      }
    },
    days(from, to) {
      if(from != null && to != null) {
        return Math.ceil(Math.abs(new Date(to) - new Date(from)) / (1000 * 60 * 60 * 24)) / 365
      }
      return null
    },
    daysToString(days) {
      let int_part = Math.trunc(days); // returns 3
      let float_part = Number((days-int_part));
      if(int_part === 0 && float_part === 0) {
        return 0 + "g"
      }
      return (int_part > 0 ? int_part + "a" : "") + " " + (float_part > 0 ? (float_part * 365).toFixed(0) + "g" : "")
    },
    validity(rate) {
      switch (rate) {
        case false:
          this.data.rate_required = ((this.data.insurance_price/this.data.sum_insured)*100).toFixed(2)
          break
        case true:
          this.data.insurance_price = ((this.data.rate_required / 100) * this.data.sum_insured).toFixed(2)
          break
      }
      if(this.data.valid_from != null && this.data.valid_to != null) {
        let days = this.days(this.data.valid_from, this.data.valid_to)
        this.data.valid_duration = this.daysToString(days)
        /*if(this.data.sum_insured != null && this.data.rate_required != null || this.data.insurance_price != null) {
          switch (rate) {
            case false:
              this.data.rate_required = ((this.data.sum_insured * days) / this.data.insurance_price).toFixed(2)
              break
            case true:
              this.data.insurance_price = ((this.data.rate_required / 100) * this.data.sum_insured * days).toFixed(2)
              break
          }
        }*/
      }
    },
    extension() {
      let days = this.days(this.data.extend_from, this.data.extend_to)
      if(days != null) {
        days = this.daysToString(days)
        if(days != null) {
          this.data.extend_duration = days
        }
      }
    },
    select(val) {
      if(val) {
        this.companies.forEach(elm => {
          this.selected.push(elm.id)
        })
      } else {
        this.selected = []
      }
    },
    getStatus(){
      console.log("get status")
      switch (this.status) {
        case 0:
        case 1:
          if(this.holders.length > 0 && this.beneficiaries.length > 0 && this.files && this.files.length > 0
              && this.data.guarantee && this.data.subject && this.data.valid_duration && this.data.sum_insured && this.data.insurance_price
              && this.data.rate_required && this.data.signature) {
              return 2
          } else if(this.$store.state.auth.role !== 'admin') {
            this.error = "Completa tutti i campi"
          }
          break
        case 2:
          if (this.filest && this.filest.length > 0) {
            return 3
          } else if(this.$store.state.auth.role !== 'admin') {
            this.error = "Relazione tecnica mancante"
          }
          break
        case 3:
          if(this.selected && this.selected.length > 0) {
            return 4
          } else if(this.$store.state.auth.role !== 'admin') {
            this.error = "Seleziona una compagnia"
          }
          break
      }
      return this.status
    },
    async store(confirmation = false) {
      this.loading = true
      this.error = null
      let res
      let status
      if (this.status === 1) {
        status = 1
      } else {
        status = this.status
      }
      if(confirmation || this.$store.state.auth.role === 'admin') {
        this.confirmation = true
        status = this.getStatus()
        if (this.error) {
          this.loading = false
          return
        }
      }
      this.data.insurance_price = String(this.data.insurance_price)
      this.data.sum_insured = String(this.data.sum_insured)
      this.data.rate_required = String(this.data.rate_required)
      if(this.data.project_value) {
        this.data.project_value = String(this.data.project_value)
      }
      // if it's new create instead update
      if(!this.$route.params.id) {
        res = await db.collection('requests').add({
          data: this.data,
          companies: "",
          status: status,
          user_id: firebase.auth().currentUser.uid,
          user: this.$store.state.auth.first_name + ' ' + this.$store.state.auth.last_name,
          created_at: firebase.firestore.Timestamp.now(),
          updated_at: firebase.firestore.Timestamp.now(),
          deleted_at: null
        })
      } else {
        if (this.filest && this.filest.length > 0) {
          await Storage.postArray(this.filest, this.$route.params.id, null, 'RelazioneTecnica').then((files) => {
            db.collection('requests').doc(this.$route.params.id).update({filest: files, status: status})
          })
        }
        if (this.filesb && this.filesb.length > 0) {
          await Storage.postArray(this.filesb, this.$route.params.id, null, 'Bozza').then((files) => {
            db.collection('requests').doc(this.$route.params.id).update({filesb: files, status: status})
          })
        }
        // update record
        await db.collection('requests').doc(this.$route.params.id).update({
          data: this.data,
          status: status,
          companies: this.selected[0] ? this.selected[0] : "",
          updated_at: firebase.firestore.Timestamp.now()
        })
        res = {id: this.$route.params.id}
      }

      // upload files
      if (this.files && this.files.length > 0) {
        let files = await Storage.postArray(this.files, res.id, null, 'DocumentazioneTecnica')
        if (files && files.length > 0) {
          await db.collection('requests').doc(res.id).update({files: files, status: status})
        }
      }
      // holders
      for (const item of this.holders) {
        item.id = await this.storeSubject('holders', item, res.id)
      }
      // beneficiaries
      for (const item of this.beneficiaries) {
        item.id = await this.storeSubject('beneficiaries', item, res.id)
      }
      // obliged
      for (const item of this.obliged) {
        item.id = await this.storeSubject('obliged', item, res.id)
      }
      // update again to trigger
      await new Promise(r => setTimeout(r, 2000));
      // fix to trigger cloud storage after upload
      await db.collection('requests').doc(res.id).update({
        updated_at: firebase.firestore.Timestamp.now()
      })
      if(!this.$route.params.id) {
        let self = this
        setTimeout(() => {
          self.$router.push({ name: 'RequestEdit', params: { id: res.id.toString() }})
        }, 3000)
        this.loading = false
      } else {
        let self = this
        setTimeout(() => {
          this.loading = false
          self.$router.go()
          self.loading = false
        }, 3000)
      }
    },
    async storeSubject(collection, item, id) {
      console.log("store");
      let res = {}
      if(!item.id) {
        res = await db.collection('requests').doc(id).collection(collection).add({
          data: item.data,
          address: item.address,
        })
      } else {
        await db.collection('requests').doc(id).collection(collection).doc(item.id).update({
          data: item.data,
          address: item.address,
        })
        res.id = item.id
      }
      let name = item.data.businessName + item.data.firstName + item.data.lastName
      // Upload documents
      if (item.docs && item.docs.id && item.docs.id.length > 0) {
        let files = await Storage.postArray(item.docs.id, id + '/' + collection + '/' +res.id, name, 'Documento')
        if (files && files.length > 0) {
          await db.collection('requests').doc(id).collection(collection).doc(res.id).update({'docs.id': files})
        }
      }
      // Upload declaration
      if (item.docs && item.docs.declaration && item.docs.declaration.length > 0) {
        let files = await Storage.postArray(item.docs.declaration, id + '/' + collection + '/' + res.id, name, 'DichiarazioneRedditi')
        if (files && files.length > 0) {
          await db.collection('requests').doc(id).collection(collection).doc(res.id).update({'docs.declaration': files})
        }
      }
      // Upload survey
      if (item.docs && item.docs.survey && item.docs.survey.length > 0) {
        let files = await Storage.postArray(item.docs.survey, id + '/' + collection + '/' + res.id, name, 'Visura')
        if (files && files.length > 0) {
          await db.collection('requests').doc(id).collection(collection).doc(res.id).update({'docs.survey': files})
        }
      }
      // Upload partial
      if (item.docs && item.docs.partial && item.docs.partial.length > 0) {
        let files = await Storage.postArray(item.docs.partial, id + '/' + collection + '/' + res.id, name, 'BilancioParziale')
        if (files && files.length > 0) {
          await db.collection('requests').doc(id).collection(collection).doc(res.id).update({'docs.partial': files})
        }
      }
      // Upload closed
      if (item.docs && item.docs.closed && item.docs.closed.length > 0) {
        let files = await Storage.postArray(item.docs.closed, id + '/' + collection + '/' + res.id, name, 'BilancioCompleto')
        if (files && files.length > 0) {
          await db.collection('requests').doc(id).collection(collection).doc(res.id).update({'docs.closed': files})
        }
      }
      // Upload other
      if (item.docs && item.docs.other && item.docs.other.length > 0) {
        let files = await Storage.postArray(item.docs.other, id + '/' + collection + '/' + res.id, name, 'Altro')
        if (files && files.length > 0) {
          await db.collection('requests').doc(id).collection(collection).doc(res.id).update({'docs.other': files})
        }
      }
      return res.id
    }
  },
  data: () => ({
    error: null,
    options: ["Pratica Positiva","Pratica Negativa"],
    confirm: false,
    confirm2: false,
    confirmation: false,
    loading: false,
    report: null,
    zip: null,
    list: [1,2,3,4,5,6],
    files: [],
    filest: [],
    filesb: [],
    companies: [],
    selected: [],
    guarantees: [],
    signatures: [],
    holders: [],
    beneficiaries: [],
    obliged: [],
    status: 1,
    disabled: false,
    completed: false,
    loadingMail: false,
    data: {
      subject: null,
      notes: null,
      guarantee: null,
      signature: null,
      valid_from: null,
      valid_to: null,
      valid_duration: null,
      extend_from: null,
      extend_to: null,
      extend_duration: null,
      sum_insured: null,
      rate_required: null,
      insurance_price: null,
      project_value: null
    }
  }),
}
</script>
